import { render, staticRenderFns } from "./locationInbound.vue?vue&type=template&id=3c4ba544&scoped=true&"
import script from "./locationInbound.vue?vue&type=script&lang=js&"
export * from "./locationInbound.vue?vue&type=script&lang=js&"
import style0 from "./locationInbound.vue?vue&type=style&index=0&id=3c4ba544&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ba544",
  null
  
)

export default component.exports